'use strict';

import $ from 'jquery';
import enquire from 'enquire.js';
import {bp} from '../../../_scripts/_helper';
import ScrollMagic from 'scrollmagic';
// import 'scrollmagic-debug';


export default class BackToTop {
  constructor() {
    let $backToTop = $('.back-to-top');

    $backToTop.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    });


    //show back to top button on mobile
    enquire.register("screen and (max-width:"+bp.minDesktop+"px)", {
      match : function() {
        // Init ScrollMagic
        var controller = new ScrollMagic.Controller();

        // build a scene
        var scene1 = new ScrollMagic.Scene({
          triggerElement: '#mainContent',
          duration: '70%'
        })
        .setClassToggle('.back-to-top', 'is-hidden') // add class to project01
        // .addIndicators({
        //   name: 'fade scene',
        //   colorTrigger: 'black',
        //   indent: 200,
        //   colorStart: '#75C695'
        // }) // this requires a plugin
        .addTo(controller);

        // build a scene
        var scene2 = new ScrollMagic.Scene({
          triggerElement: '.footer',
          triggerHook: 1,
          offset: 45
        })
        .setClassToggle('.back-to-top', 'no-fixed') // add class to project01
        // .addIndicators({
        //   name: 'fade scene backtotop',
        //   colorTrigger: 'blue',
        //   indent: 200,
        //   colorStart: '#75C695'
        // }) // this requires a plugin
        .addTo(controller);

      }
    });

  }
}
